<template>
  <div class="couponCard">
    <va-card class="card">
      <template slot="header">
        <h1 class="mt-0 mb-0">{{ coupon.code }}</h1>
        <div class="couponHeader">
          <div class="editButtons">
            <va-button color="info" v-if="!editMode" @click="editMode = true">Edit</va-button>
            <va-button color="danger" v-if="editMode" @click="localCancelAction">Cancel</va-button>
            <va-button color="success" v-if="editMode" :disabled="!modified" @click="saveCoupon">Save</va-button>
          </div>
        </div>
      </template>

      <div v-if="!editMode">
        Coupon Type: {{ coupon.type }}
        <br />
        Uses Limit: {{ coupon.limit }}
        <br />
      </div>

      <div v-if="editMode">
        <div id="codeDiv" class="row" v-if="add">
          <div class="flex" style="display: flex; align-items: center">Coupon Code:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              v-model="coupon.code"
              placeholder="CouponCode"
              style="display: flex; align-self: bottom"
              @change="couponChanged"
            />
          </div>
        </div>

        <div id="couponTypeDiv" class="row">
          <div class="flex" style="display: flex; align-items: center">Coupon Type:</div>
          <div class="flex md4 sm6 xs12" style="align-items: center">
            <va-select v-model="coupon.type" :options="couponTypes" @selected="couponChanged" />
          </div>
        </div>

        <div id="UsesLimitDiv" class="row">
          <div class="flex" style="display: flex; align-items: center">Uses Limit:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-input
              v-model="coupon.limit"
              placeholder="Uses Limit"
              style="display: flex; align-self: bottom"
              @input="couponChanged"
            />
          </div>
        </div>

        <div id="SquareIdDiv" class="row" v-if="add">
          <div class="flex" style="display: flex; align-items: center">Square Discount Id:</div>
          <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
            <va-select
              v-model="coupon.squareId"
              :options="squareIdList"
              @selected="couponChanged"
              placeholder="Select a Discount"
            />
          </div>
        </div>
      </div>
      Number of Uses: {{ coupon.uses }}
      <br />
      <div id="lightDiv" class="row">
        <div class="flex" style="display: flex; align-items: center">Active:</div>
        <div class="flex md4 sm6 xs12" style="display: flex; align-items: center">
          <va-toggle v-model="coupon.active" @input="couponChanged" />
        </div>
      </div>
    </va-card>
  </div>
</template>

<script>
const fb = require('./../../firebase/firebaseConfig')

export default {
  name: 'CouponCard',
  props: {
    coupon: {
      type: Object,
      required: false,
      default: () => {
        return {
          active: false,
          code: 'CouponCode',
          limit: 1,
          squareId: '',
          type: 'LimitUse',
          uses: 0,
        }
      },
    },
    add: { type: Boolean, required: false },
  },
  data() {
    return {
      modified: false,
      couponTypes: ['LimitUseUser', 'LimitUse', 'Unlimited'],
      editMode: false,
      squareIdList: [],
      squareDiscountList: [],
    }
  },
  methods: {
    couponChanged: function () {
      this.modified = true
    },
    saveCoupon: async function () {
      this.$store.commit('setLoading', true)

      this.coupon.squareId = this.squareDiscountList.filter(
        (discount) => discount.discount_data.name === this.coupon.squareId
      )[0]

      var addCoupon = fb.funcs.httpsCallable('addCoupon')
      await addCoupon({
        storeId: this.$store.getters.currentStore.id,
        couponCode: this.coupon.code,
        couponType: this.coupon.type,
        couponLimit: this.coupon.limit,
        squareDiscountId: this.coupon.squareId,
        active: this.coupon.active,
        implnt: 'BRIM',
      })

      this.$emit('reload')
      this.editMode = false
      console.log('Done with child function')
    },
    localCancelAction: function () {
      if (this.add) {
        this.$emit('cancel')
      }

      this.editMode = false
    },
  },
  mounted: async function () {
    if (this.add) {
      this.editMode = true

      var getDiscounts = fb.funcs.httpsCallable('getAllDiscounts')
      this.squareDiscountList = (
        await getDiscounts({
          implnt: 'SQUARE',
          storeId: this.$store.getters.currentStore.id.toString(),
        })
      ).data

      this.squareIdList = this.squareDiscountList.map((discount) => discount.discount_data.name)
    }
  },
}
</script>

<style lang="scss">
.card {
  background-color: #fcfcfc;
}

.couponCard {
  padding: 1em 0 1em 0;
}

.va-input-wrapper,
.va-select-wrapper,
.va-toggle {
  margin-bottom: 0;
}

.couponHeader {
  display: inline-block;
  width: 100%;
}

.title {
  float: left;
}

.editButtons {
  float: right;
}
</style>
